import { cn } from "utils/helpers";

interface ListHorizontalItemProps {
	title: string;
	value: React.ReactNode;
	valueClassName?: string;
}

export const ListHorizontalItem: React.FC<ListHorizontalItemProps> = ({
	title,
	value,
	valueClassName,
}) => (
	<div className="flex w-full flex-col gap-1 break-words sm:flex-row sm:items-start">
		<p className="break-words text-gray-text-400 sm:w-48">{title}</p>
		<p
			className={cn(
				"break-words font-roboto font-medium text-primary-900",
				valueClassName
			)}
			style={{ fontSize: "16px", wordBreak: "break-word" }}
		>
			{value ?? "-"}
		</p>
	</div>
);
